class SaveIncludedAccreditationQuantityDto {
  includedAccreditationQuantity!: number;
}

export default SaveIncludedAccreditationQuantityDto;
